export const GENERAL_TIMEOUT = 15000;

export const MESSAGE_SYSTEM_FAILED = `System failed. Please, contact technical support or try again later.`;
export const MESSAGE_UNAUTHORIZED_USER = `You are not logged in.`;
export const MESSAGE_UNAUTHORIZED_SYSTEM = `System is not authorized.`;
export const MESSAGE_FAILURE = `Failed to initialize SDK.`;
export const MESSAGE_FAILED_ENGAGEMENT = `Failed to create an engagement.`;
export const MESSAGE_ENGAGEMENT_TERMINATED = `Your engagement is terminated.`